import type { CanActivateFn } from '@angular/router';

import { costClientRedirect } from './cost-client-redirect.guard';
import { roleGuard } from './role.guard';
import { sessionGuard } from '../session/session.guard';

/**
 * Sequential access control for `/cost`.
 *
 * Angular evaluates the functions in one `canActivate` array concurrently. That is harmless for
 * pure guards, but `roleGuard` records a denial event, so it must not run when a client caller is
 * being relocated to `/usage`. Keep the three established decisions in order and stop at the first
 * redirect.
 */
export const costAccessGuard: CanActivateFn = (route, state) => {
  const authenticated = sessionGuard(route, state);
  if (authenticated !== true) return authenticated;

  const relocated = costClientRedirect(route, state);
  if (relocated !== true) return relocated;

  return roleGuard(route, state);
};